module.exports = __webpack_public_path__ + "img/cx5-gt-19.4663bcc4.png";